<template>
  <v-app>
    <template v-if="$route.meta.requiresAuth">
      <navigation-drawer-component />
      <app-bar-component />
    </template>
    <transition
      name="fade"
      mode="out-in"
    >
      <router-view />
    </transition>
    <v-snackbar
      v-model="snackbar.active"
      color="eon"
    >
      {{ snackbar.message }}
    </v-snackbar>
    <BaseDialog />
  </v-app>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import AppBarComponent from './components/AppBarComponent.vue';
import NavigationDrawerComponent from './components/NavigationDrawerComponent.vue';
import BaseDialog from './components/atoms/BaseDialog.vue';
import isUserLoggedIn from './helpers/isUserLoggedIn';

export default {
  name: 'App',

  components: {
    NavigationDrawerComponent, AppBarComponent, BaseDialog,
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
      snackbar: 'getSnackbar',
      perfil: 'getPerfil',
    }),
  },

  async mounted() {
    if (isUserLoggedIn()) {
      this.SET_PERFIL(localStorage.getItem('perfil'));
      this.SET_NOMBRE(localStorage.getItem('nombre'));
      this.SET_ID_PERSONAL(localStorage.getItem('idPersonal'));
      this.SET_ID_USUARIO(localStorage.getItem('idUsuario'));
    }
    this.DISABLE_LOADER();
  },

  methods: {
    ...mapMutations([
      'DISABLE_LOADER',
      'SET_PERFIL',
      'SET_NOMBRE',
      'SET_ID_PERSONAL',
      'SET_ID_USUARIO',
    ]),
    ...mapActions(['getUserInfo', 'login']),
  },
};
</script>

<style scoped>
    .fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }
</style>
